/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InspectionCategoryTypeDto } from './InspectionCategoryTypeDto';
import {
    InspectionCategoryTypeDtoFromJSON,
    InspectionCategoryTypeDtoFromJSONTyped,
    InspectionCategoryTypeDtoToJSON,
    InspectionCategoryTypeDtoToJSONTyped,
} from './InspectionCategoryTypeDto';
import type { EquipmentMapDto } from './EquipmentMapDto';
import {
    EquipmentMapDtoFromJSON,
    EquipmentMapDtoFromJSONTyped,
    EquipmentMapDtoToJSON,
    EquipmentMapDtoToJSONTyped,
} from './EquipmentMapDto';

/**
 * 
 * @export
 * @interface InspectionDto
 */
export interface InspectionDto {
    /**
     * 
     * @type {number}
     * @memberof InspectionDto
     */
    inspectionId?: number;
    /**
     * 
     * @type {string}
     * @memberof InspectionDto
     */
    externalId?: string;
    /**
     * 
     * @type {Array<EquipmentMapDto>}
     * @memberof InspectionDto
     */
    equipmentMap?: Array<EquipmentMapDto>;
    /**
     * 
     * @type {number}
     * @memberof InspectionDto
     */
    assetId?: number;
    /**
     * 
     * @type {number}
     * @memberof InspectionDto
     */
    siteId?: number;
    /**
     * 
     * @type {number}
     * @memberof InspectionDto
     */
    mineLocationId?: number;
    /**
     * 
     * @type {string}
     * @memberof InspectionDto
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof InspectionDto
     */
    inspectionDate?: Date;
    /**
     * 
     * @type {Array<InspectionCategoryTypeDto>}
     * @memberof InspectionDto
     */
    categoriesTypes?: Array<InspectionCategoryTypeDto>;
    /**
     * 
     * @type {boolean}
     * @memberof InspectionDto
     */
    isNew?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InspectionDto
     */
    metaData?: string | null;
}

/**
 * Check if a given object implements the InspectionDto interface.
 */
export function instanceOfInspectionDto(value: object): value is InspectionDto {
    return true;
}

export function InspectionDtoFromJSON(json: any): InspectionDto {
    return InspectionDtoFromJSONTyped(json, false);
}

export function InspectionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InspectionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'inspectionId': json['inspectionId'] == null ? undefined : json['inspectionId'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'equipmentMap': json['equipmentMap'] == null ? undefined : ((json['equipmentMap'] as Array<any>).map(EquipmentMapDtoFromJSON)),
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'siteId': json['siteId'] == null ? undefined : json['siteId'],
        'mineLocationId': json['mineLocationId'] == null ? undefined : json['mineLocationId'],
        'name': json['name'] == null ? undefined : json['name'],
        'inspectionDate': json['inspectionDate'] == null ? undefined : (new Date(json['inspectionDate'])),
        'categoriesTypes': json['categoriesTypes'] == null ? undefined : ((json['categoriesTypes'] as Array<any>).map(InspectionCategoryTypeDtoFromJSON)),
        'isNew': json['isNew'] == null ? undefined : json['isNew'],
        'metaData': json['metaData'] == null ? undefined : json['metaData'],
    };
}

export function InspectionDtoToJSON(json: any): InspectionDto {
    return InspectionDtoToJSONTyped(json, false);
}

export function InspectionDtoToJSONTyped(value?: InspectionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'inspectionId': value['inspectionId'],
        'externalId': value['externalId'],
        'equipmentMap': value['equipmentMap'] == null ? undefined : ((value['equipmentMap'] as Array<any>).map(EquipmentMapDtoToJSON)),
        'assetId': value['assetId'],
        'siteId': value['siteId'],
        'mineLocationId': value['mineLocationId'],
        'name': value['name'],
        'inspectionDate': value['inspectionDate'] == null ? undefined : ((value['inspectionDate']).toISOString()),
        'categoriesTypes': value['categoriesTypes'] == null ? undefined : ((value['categoriesTypes'] as Array<any>).map(InspectionCategoryTypeDtoToJSON)),
        'isNew': value['isNew'],
        'metaData': value['metaData'],
    };
}

